export default __webpack_public_path__ + "static/media/ins.d593bc9d.jpg";